import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface RSVPStatsProps {
  totalResponses: number;
  attendingCeremony: number;
  attendingReception: number;
  blessingsReceived: number;
}

const RSVPStats = ({ totalResponses, attendingCeremony, attendingReception, blessingsReceived }: RSVPStatsProps) => {
  const stats = [
    {
      icon: 'UserGroupIcon',
      label: 'Total Responses',
      value: totalResponses,
      color: 'text-primary',
      bgColor: 'bg-primary/10',
    },
    {
      icon: 'HeartIcon',
      label: 'Attending Ceremony',
      value: attendingCeremony,
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
    },
    {
      icon: 'SparklesIcon',
      label: 'Attending Reception',
      value: attendingReception,
      color: 'text-accent',
      bgColor: 'bg-accent/10',
    },
    {
      icon: 'ChatBubbleLeftEllipsisIcon',
      label: 'Blessings Shared',
      value: blessingsReceived,
      color: 'text-success',
      bgColor: 'bg-success/10',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="bg-card rounded-lg p-6 border border-border shadow-sm hover:shadow-md transition-all duration-300"
        >
          <div className="flex items-center space-x-4">
            <div className={`w-12 h-12 rounded-full ${stat.bgColor} flex items-center justify-center flex-shrink-0`}>
              <Icon name={stat.icon as any} size={24} className={stat.color} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-inter text-2xl font-bold text-foreground">
                {stat.value}
              </p>
              <p className="font-inter text-xs text-muted-foreground mt-0.5">
                {stat.label}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RSVPStats;